export default {
    nav: {
        home: "Home",
        products: "Products",
        contact: "Contact",
        myAccount: "My Account",
        logout: "Logout",
        loginRegister: "Login / Register",
        login: "Login",
        register: "Register",
        account: "Account",
        signOut: "Sign out",
        openMenu: "Open menu"
    },
    footer: {
        tagline: "The essence of Vietnamese rattan and bamboo weaving, bringing a touch of nature into modern living spaces.",
        buyOnline: "Buy Online",
        catalogue: "Download Catalogue",
        generalInfo: "General Info",
        contact: "Contact",
        shippingPolicy: "Shipping Policy",
        warrantyPolicy: "Warranty Policy",
        faq: "FAQ",
        aboutUs: "About Us",
        aboutText:
            "Rattanovi - a leading handicraft bamboo/rattan brand with 15 years of experience. We take pride in bringing eco-friendly products that combine craftsmanship with nature.",
        phone: "0325738794 (FB/Zalo)",
        handmadeWithCare: "Handmade with care · Rattanovi"
    },
    home: {
        craftTag: "Handmade rattan & bamboo",
        heroDesc:
            "Handmade products from natural materials, curated for warm, sustainable living spaces with a story to tell.",
        viewProducts: "View products",
        ourStory: "Our story",
        newProductsTag: "New arrivals",
        curatedTitle: "Curated for your home",
        viewAll: "View all",
        fromVillageTag: "From the craft village",
        keepDetailTitle: "Keeping it rustic, down to the details",
        storyText:
            "Every product is made through weaving, material treatment and handmade finishing. Design prioritizes function, durability and the natural beauty of Vietnamese rattan and bamboo.",
        artisans: "artisans",
        villages: "craft villages",
        natural: "natural",
        collectionsTag: "Collections",
        easyStyleTitle: "Easy to style in every corner",
        quote: "“A good product isn’t just beautiful on a shelf — it slows down everyday life and makes it more pleasant.”",
        collectionLivingTitle: "Living space",
        collectionLivingText: "Gentle decor pieces for the living room, coffee table and reading corner.",
        collectionKitchenTitle: "Kitchen & dining",
        collectionKitchenText: "Trays, baskets, boxes and handmade items for everyday life.",
        collectionGiftTitle: "Handmade gifts",
        collectionGiftText: "Products made from natural materials, perfect for a thoughtful gift.",
        heroImageAlt: "Vietnamese craft living space",
        storyImageAlt: "Traditional craftsmanship"
    },
    menu: {
        title: "Rattan & Bamboo Collection",
        subtitle:
            "Discover the rustic, refined beauty of traditional handmade products, bringing a touch of nature into modern living spaces.",
        categoryHeading: "Category",
        allProducts: "All products",
        materialHeading: "Material",
        sortHeading: "Sort",
        searchPlaceholder: "Search products...",
        searchButton: "Search",
        sortNewest: "Newest",
        sortPriceAsc: "Price: low to high",
        searchByName: "Product name",
        searchByBrand: "Brand",
        searchByCountry: "Origin",
        materialNatural: "Natural rattan",
        materialSmokedBamboo: "Smoked bamboo",
        materialReed: "Woven reed",
        materialMixed: "Mixed"
    },
    productCard: {
        size: "Size",
        reviews: "{{count}} reviews",
        noReviews: "No reviews yet",
        addToCart: "Add to cart",
        edit: "Edit",
        delete: "Delete"
    },
    product: {
        imageAlt: "Image {{index}}",
        reviewsCount: "{{count}} reviews",
        inStock: "In stock",
        outOfStock: "Out of stock",
        addToCart: "Add to cart",
        type: "Type",
        size: "Size",
        length: "Length",
        width: "Width",
        height: "Height",
        diameter: "Diameter",
        origin: "Origin",
        year: "Year",
        material: "Material / care",
        description: "Description",
        reviewsTitle: "Reviews",
        noReviews: "There are no reviews for this product yet.",
        yourName: "Your name",
        yourMark: "Your rating",
        messageText: "Message",
        postReview: "Post a review"
    },
    cart: {
        title: "Cart",
        empty: "Your cart is empty",
        emptyDesc: "Explore our rattan & bamboo collection and add items you love.",
        continueShopping: "Continue shopping",
        orderSummary: "Order summary",
        subtotal: "Subtotal ({{count}} items)",
        shippingFee: "Shipping fee",
        shippingCalcAtCheckout: "Calculated at checkout",
        total: "Total",
        checkout: "Checkout",
        decreaseAria: "Decrease quantity",
        increaseAria: "Increase quantity",
        remove: "Remove"
    },
    order: {
        title: "Checkout",
        firstName: "First name:",
        lastName: "Last name:",
        city: "City:",
        address: "Address:",
        postIndex: "Postal code:",
        phone: "Phone number:",
        email: "Email:",
        firstNamePlaceholder: "Enter your first name",
        lastNamePlaceholder: "Enter your last name",
        cityPlaceholder: "Enter your city",
        addressPlaceholder: "Enter your address",
        postIndexPlaceholder: "Enter your postal code",
        phonePlaceholder: "0912 345 678",
        emailPlaceholder: "example@gmail.com",
        payment: "Total:",
        placeOrder: "Place order",
        itemPrice: "Price:",
        itemQuantity: "Quantity:"
    },
    orderFinalize: {
        thankYou: "Thank you for your order!",
        orderNumber: "Your order number is: {{id}}"
    },
    login: {
        heroTitle: "Preserving traditional beauty in a modern living space.",
        heroDesc:
            "A journey bringing the essence of Vietnamese rattan weaving into every home, where each product tells a story of care and craftsmanship.",
        heroBadge: "+2,000 artisans and customers on this journey",
        welcomeBack: "Welcome back",
        subtitle: "Please log in to keep exploring our handmade pieces.",
        email: "Email",
        password: "Password",
        forgotPassword: "Forgot password?",
        remember: "Remember me",
        submit: "Log in",
        noAccount: "Don't have an account?",
        registerNow: "Register now",
        orContinueWith: "Or continue with",
        togglePassword: "Show/hide password"
    },
    registration: {
        heroTitle: "Start your journey with Vietnamese craftsmanship.",
        heroDesc: "Create an account to get offers, track orders and save the rattan pieces you love.",
        heroBadge: "+2,000 artisans and customers on this journey",
        title: "Start your journey",
        subtitle: "Create an account to get offers and save your favorite items.",
        successMessage: "Registration successful! Please check your email to activate your account.",
        firstName: "First name",
        firstNamePlaceholder: "e.g. John",
        lastName: "Last name",
        lastNamePlaceholder: "e.g. Smith",
        email: "Email",
        password: "Password",
        passwordPlaceholder: "At least 6 characters",
        confirmPassword: "Confirm password",
        confirmPasswordPlaceholder: "Re-enter your password",
        submit: "Create account",
        haveAccount: "Already have an account?",
        loginNow: "Log in"
    },
    forgotPassword: {
        title: "Forgot password?",
        instructions: "Enter the email address you used to create your account.",
        email: "Email:",
        emailPlaceholder: "Email",
        emailRequired: "Please enter your email!",
        send: "Send"
    },
    resetPassword: {
        title: "Reset password",
        password: "Password:",
        passwordPlaceholder: "Password",
        confirmPassword: "Confirm password:",
        confirmPasswordPlaceholder: "Confirm password",
        reset: "Reset"
    },
    contacts: {
        title: "Contact",
        phone: "Phone: ",
        phoneValue: "0325 738 794 (FB/Zalo)",
        email: "Email: ",
        workingHours: "Working hours",
        workingHoursText: "Open from 08:00 to 20:00, every day of the week.",
        onlineOrders: "Online orders are accepted 24/7.",
        delivery: "Delivery",
        deliveryText: "Orders are shipped via courier service.",
        connectWithUs: "Connect with us"
    },
    chat: {
        supportTitle: "Rattanovi Support",
        responseTime: "Usually replies within minutes",
        close: "Close",
        greeting: "Hi there 👋 Need advice on our rattan & bamboo products? Send us a message!",
        inputPlaceholder: "Type a message...",
        send: "Send",
        openAria: "Chat with us"
    },
    account: {
        fallbackName: "Account",
        roleCustomer: "Customer",
        personalInfo: "Personal information",
        personalInfoDesc: "Update your shipping information",
        changePassword: "Change password",
        myOrders: "My orders",
        myOrdersDesc: "Track your placed orders",
        greeting: "Hello, {{name}}!",
        customerSubtitle: "Welcome back. Manage your orders and personal information here.",
        noOrders: "You don't have any orders yet",
        orderId: "Order ID",
        orderDate: "Order date",
        customerName: "Customer",
        email: "Email",
        totalAmount: "Total amount",
        actions: "Actions",
        viewDetails: "View details",
        orderNumberTitle: "Order #{{id}}",
        customerInfo: "Customer information",
        orderInfo: "Order information",
        fullName: "Full name",
        orderTotal: "Order total",
        productCode: "Product code",
        vendor: "Brand",
        productName: "Product name",
        quantity: "Quantity",
        unitPrice: "Unit price",
        lineTotal: "Line total"
    },
    changePassword: {
        title: "Change password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        passwordPlaceholder: "Password",
        submit: "Change password"
    },
    personalData: {
        title: "Personal information",
        email: "Email",
        firstName: "First name",
        lastName: "Last name",
        city: "City",
        address: "Address",
        phone: "Phone number",
        postIndex: "Postal code",
        edit: "Edit",
        hide: "Hide",
        firstNameLabel: "First name:",
        lastNameLabel: "Last name:",
        cityLabel: "City:",
        addressLabel: "Address:",
        phoneLabel: "Phone number:",
        postIndexLabel: "Postal code:",
        firstNamePlaceholder: "Enter your first name",
        lastNamePlaceholder: "Enter your last name",
        cityPlaceholder: "Enter your city",
        addressPlaceholder: "Enter your address",
        phonePlaceholder: "Enter your phone number",
        postIndexPlaceholder: "Enter your postal code",
        save: "Save"
    }
};
